import { Component, OnInit } from "@angular/core";
import { TabIdList } from "../shared/models/tab.model";
import { Router, RouterModule } from "@angular/router";
import { RouteEnum } from "../shared/models/routes.model";

@Component({
  selector: "app-inbox-screen",
  templateUrl: "./inbox-screen.component.html",
  imports: [RouterModule],
  standalone: true,
})
export class InboxScreenComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}
}
